<div class="card-metric">
  <span class="card-metric__value">{{ value }}</span>
  <span class="card-metric__label">{{ label }}</span>
  <span
    *ngIf="delta"
    class="card-metric__delta"
    [ngClass]="trendClass(trend)"
    [attr.aria-label]="'Change: ' + delta">
    {{ trendArrow(trend) }}&thinsp;{{ delta }}
  </span>
</div>
